'use client'
import { createContext, useContext } from 'react'
import { BrandingLayer } from '@/types/branding'

/**
 * Exposes the BrandingLayer resolved in AppProvider to the rest of the tree
 * (useBrandAssets, BrandSlot) without touching the cinematics store — team
 * branding must never be readable/writable through useCinematicsStore.
 */
const BrandingLayerContext = createContext<BrandingLayer>(null)

export const BrandingLayerProvider = BrandingLayerContext.Provider

export const useBrandingLayerContext = (): BrandingLayer => useContext(BrandingLayerContext)
